import { viteAppBaseUrl } from '@/constants/env';

/** make sure the file exists in public */
export const getPmsRingtoneUrl = (customRingtone?: string) => {
  if (!customRingtone) {
    return;
  }

  return `${viteAppBaseUrl()}/audio/${customRingtone.trim()}.mp3`;
};
